"use client";

/**
 * App-level error boundary. A render error in any page used to white-screen the
 * whole app with "client-side exception"; now it shows a recoverable message
 * and surfaces the actual error so it's diagnosable instead of opaque.
 */
import { useEffect } from "react";

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    // Visible in the browser console for diagnosis.
    console.error("App error boundary:", error);
  }, [error]);
  return (
    <div className="mx-auto max-w-lg px-4 py-16 text-center">
      <h1 className="text-lg font-semibold text-[var(--foreground)]">Something went wrong on this page</h1>
      <p className="mt-2 text-sm text-[var(--muted)]">The rest of the app is fine — try again, or head back to Today.</p>
      <pre className="mt-3 overflow-x-auto rounded-md border border-[var(--border)] bg-[var(--surface)] p-2 text-left text-[11px] text-[var(--muted)]">{error?.message || "Unknown error"}{error?.digest ? `\n(${error.digest})` : ""}</pre>
      <div className="mt-4 flex justify-center gap-3">
        <button onClick={reset} className="rounded-md bg-[var(--accent)] px-4 py-2 text-sm font-medium text-white">Try again</button>
        <a href="/today" className="rounded-md border border-[var(--border)] px-4 py-2 text-sm">Today</a>
      </div>
    </div>
  );
}
